import { createActions, createReducer } from 'reduxsauce';

import { setInitial, updateProp } from 'Reducers/shared';

export const { Types, Creators } = createActions(
  {
    checkIn: null,
    checkOut: ['id'],
    checkOutError: ['error'],
    checkOutSuccess: ['checkInId'],
    checkOutSuccessHandler: ['userId', 'checkInId'],
    get: null,
    getAddress: ['payload', 'userId'],
    getCitiesByPostCode: ['data'],
    getCitiesByPostCodeSuccess: ['payload'],
    set: ['payload', 'userId'],
    setAddress: ['payload', 'userId', 'checkInId'],
    updateProp: ['key', 'value'],
    verifyCheckIn: ['flowId'],
    verifyCheckInSuccess: ['payload', 'flowId']
  },
  { prefix: 'checkIn/' }
);

const initialState = {};

const initialCheckInsState = {
  checkIns: []
};

export const set = (state, { payload, userId }) => {
  const newState = setInitial(state, userId, initialCheckInsState);
  newState[userId]['checkIns'] = payload;
  return newState;
};

export const checkOutSuccessHandler = (state, { userId, checkInId }) => {
  const newState = { ...state };

  if (newState[userId]) {
    newState[userId].checkIns = newState[userId]?.checkIns?.filter(checkIn => checkIn.id !== checkInId);
  }

  return newState;
};

export const setAddress = (state, { payload, userId, checkInId }) => {
  let checkIndex;
  for (const [index, c] of state[userId].checkIns.entries()) {
    if (c.id === checkInId) {
      checkIndex = index;
    }
  }

  // store only the first 10,000 addresses to prevent excessive memory usage
  const cappedPayload = Array.isArray(payload) ? payload.slice(0, 10000) : payload;

  state[userId].checkIns[checkIndex].address = cappedPayload;

  return { ...state };
};

export const getCitiesByPostCodeSuccess = (state, { payload, userId, checkInId }) => {
  const checkIns = state[userId]?.checkIns || [];
  const checkIndex = checkIns.findIndex(checkIn => checkIn.id === checkInId);

  if (checkIndex !== -1) {
    checkIns[checkIndex].cities = payload;
  }

  return { ...state };
};

export const checkInCities = state => state.checkIn[state.user.id]?.checkIns[0]?.cities;
export const checkInCountry = state => state.checkIn[state.user.id]?.checkIns[0]?.country;
export const checkedInPostCodes = state => state.checkIn[state.user.id]?.checkIns[0]?.selected_postcodes;

export default createReducer(initialState, {
  [Types.CHECK_OUT_SUCCESS_HANDLER]: checkOutSuccessHandler,
  [Types.GET_CITIES_BY_POST_CODE_SUCCESS]: getCitiesByPostCodeSuccess,
  [Types.SET_ADDRESS]: setAddress,
  [Types.SET]: set,
  [Types.UPDATE_PROP]: updateProp
});
